
import { Form } from "@/components/ui/form";
import { Profile } from "@/hooks/auth/profile/types";
import LocationFormHeader from "./location/LocationFormHeader";
import LocationFormFields from "./location/LocationFormFields";
import LocationFormActions from "./location/LocationFormActions";
import { useLocationForm } from "./location/useLocationForm";

interface ProfileLocationFormProps {
  profile: Profile | null;
  onUpdate: () => Promise<boolean>;
}

const ProfileLocationForm = ({ profile, onUpdate }: ProfileLocationFormProps) => {
  const { form, isSubmitting, isDetecting, onSubmit, detectLocation } = useLocationForm(profile, onUpdate);

  if (!form.control) {
    console.error("Form control is missing in ProfileLocationForm");
    return <div>Error loading form. Please refresh the page.</div>;
  }

  return (
    <div className="space-y-6">
      <LocationFormHeader />

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <LocationFormFields control={form.control} />
          <LocationFormActions 
            isDetecting={isDetecting} 
            isSubmitting={isSubmitting} 
            detectLocation={detectLocation} 
          />
        </form>
      </Form>
    </div>
  );
};

export default ProfileLocationForm;
